import { useDevStore } from '../../store/useDevStore';

/** Preferências de tours interativos (localStorage). */

const ENABLED_KEY = 'ac_tours_enabled';
/** Auto-iniciar / auto-gerar tour ao abrir a página. Default: desligado. */
const AUTO_START_KEY = 'ac_tours_auto';

export function areToursEnabled(): boolean {
  try {
    const devSettings = useDevStore.getState().settings;
    if (devSettings && devSettings.showTour === false) return false;

    const raw = localStorage.getItem(ENABLED_KEY);
    // Default: desligado se não explicitamente ativado
    if (raw === null) return false;
    return raw === '1' || raw === 'true';
  } catch {
    return false;
  }
}

/** Se true, prefetch + walkthrough ao entrar na página. Default: false. */
export function areAutoToursEnabled(): boolean {
  try {
    const devSettings = useDevStore.getState().settings;
    if (devSettings && (devSettings.showTour === false || devSettings.autoStartTour === false)) return false;

    const raw = localStorage.getItem(AUTO_START_KEY);
    if (raw === null) return false;
    return raw === '1' || raw === 'true';
  } catch {
    return false;
  }
}

export function setAutoToursEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(AUTO_START_KEY, enabled ? '1' : '0');
    window.dispatchEvent(
      new CustomEvent('ac-tours-auto-changed', { detail: { enabled } }),
    );
  } catch {
    /* ignore */
  }
}

export function setToursEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(ENABLED_KEY, enabled ? '1' : '0');
    window.dispatchEvent(new CustomEvent('ac-tours-pref-changed', { detail: { enabled } }));
  } catch {
    /* ignore */
  }
}

export function tourDoneKey(perfil: string, tourId: string): string {
  return `ac_tour_done:${perfil}:${tourId}`;
}

export function isTourDone(perfil: string, tourId: string): boolean {
  try {
    return localStorage.getItem(tourDoneKey(perfil, tourId)) === '1';
  } catch {
    return false;
  }
}

export function markTourDone(perfil: string, tourId: string): void {
  try {
    localStorage.setItem(tourDoneKey(perfil, tourId), '1');
  } catch {
    /* ignore */
  }
}

/** Permite o auto-tour na próxima visita (sem desligar tours). */
export function resetTourDone(perfil: string, tourId: string): void {
  try {
    localStorage.removeItem(tourDoneKey(perfil, tourId));
  } catch {
    /* ignore */
  }
}

/** Seletor estável a partir da rota do menu. */
export function navTourSelector(to: string): string {
  return `[data-tour="${navTourId(to)}"]`;
}

export function navTourId(to: string): string {
  if (!to || to === '#') return 'nav.folder';
  const clean = to.replace(/^\//, '').replace(/\/+/g, '.').replace(/[^a-zA-Z0-9._-]/g, '');
  return `nav.${clean || 'home'}`;
}

export function sectionTourId(title: string): string {
  const slug = title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `nav.section.${slug || 'menu'}`;
}

export function sectionTourSelector(title: string): string {
  return `[data-tour="${sectionTourId(title)}"]`;
}
